// Inside of the sections you can call 
// waitForData((){startCountdown("end_date", "section-{{secion.id}}");}))

function startCountdown(endTime, elementId) {
    const countdownEl = document.getElementById(elementId);
    function updateCountdown() {
        const now = new Date().getTime();
        const distance = new Date(endTime).getTime() - now;

        if (distance < 0) {
            countdownEl.innerHTML = "EXPIRED";
            return;
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);
        const daysEl = document.querySelector(`#${elementId} #days`);
        const hoursEl = document.querySelector(`#${elementId} #hours`);
        const minutesEl = document.querySelector(`#${elementId} #minutes`);
        const secondsEl = document.querySelector(`#${elementId} #seconds`);

        if (daysEl) {
            daysEl.innerHTML =  (days < 10 ? "0" + days : days);
        }  
        if (hoursEl){
            hoursEl.innerHTML =  (hours < 10 ? "0" + hours : hours);
        }  
        if (minutesEl){
            minutesEl.innerHTML =  (minutes < 10 ? "0" + minutes : minutes);
        }  
        if (secondsEl){
            secondsEl.innerHTML =  (seconds < 10 ? "0" + seconds : seconds);
        }  
    }
    updateCountdown();
    setInterval(updateCountdown, 1000);
}

function addMultiplier(data, wrapperId) {
    const elems = document.querySelectorAll(`#${wrapperId} .giveaway-multiplier`);
    if (elems) {
        if (parseInt(data) > 1) {
            elems.forEach((elem)=>elem.textContent = data + 'X');
        }
    }
}
function addProductEntries(data, wrapperId, price) {
    const elems = document.querySelectorAll(`#${wrapperId} .giveaway-entries`);
    const total = parseInt(data) * parseInt(price);
    if (elems) {
        if (parseInt(data) > 1) {
            elems.forEach((elem)=>elem.textContent = total);
        }
    }
}
function addProductEntriesBonus(data, wrapperId, price, id, quantity) {
    const elems = document.querySelectorAll(`#${wrapperId} .giveaway-entries`);
    const multiplier = data.entryCalculation.bonusPeriod.multiplier;
    let total = parseInt(multiplier) * parseInt(price);
    const productBonuses = data.entryCalculation.productBonuses;
    const productSuperBonuses = data.entryCalculation.superBonuses;
    Object.keys(productBonuses).forEach(productId => {
        if (parseInt(productId) === parseInt(id)) {
            total = total + (productBonuses[productId].bonusEntries * parseInt(quantity));
        }
    })
    Object.keys(productSuperBonuses).forEach(productId => {
        if (parseInt(productId) === parseInt(id)) {
            total = total + (productSuperBonuses[productId].bonusEntries * parseInt(quantity));
        }
    })
    if (elems) {
        if (parseInt(total) > 1) {
            elems.forEach((elem)=>elem.textContent = total);
        }
    }
}

function getTotalEntries(wrapperId){
    const allEntries = document.querySelectorAll('.cart-drawer__content .giveaway-entries');
    let total = 0;
    allEntries.forEach(entrie => {
        total = total + parseInt(entrie.textContent);
    });
    const elems = document.querySelectorAll(`#${wrapperId} .giveaway-entries`);
    if (elems) {
        if (parseInt(total) > 1) {
            elems.forEach((elem)=>elem.textContent = total);
        }
    }
}
function addEntries(data, wrapperId) {
    const elems = document.querySelectorAll(`#${wrapperId} .giveaway-entries`);
    if (elems) {
        if (parseInt(data) > 1) {
            elems.forEach((elem)=>elem.textContent = data + 'X');
        }
    }
}
function waitForData(callback, timeout = 10000) {
    const startTime = Date.now();
    function checkDiv() {
        if (window.GiveawayGator?.config) {
            callback();
        } else if (Date.now() - startTime < timeout) {
            setTimeout(checkDiv, 500); 
        }
    }
    checkDiv();
}